import React from "react";
import PropTypes from "prop-types";

const Images = ({ images }) => {
  return (
    <div className="bg-gray-50 py-10">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-10">
          Our Previous projects
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {images.map((image, index) => (
            <div
              key={index}
              className="overflow-hidden rounded-lg shadow-md hover:scale-105 transition-transform duration-300 ease-in-out"
            >
              <img
                src={image}
                alt="ANS SAFETY NETS ,safety nets in bengaluru,"
                tittle="ANS SAFETY NETS ,safety nets in bengaluru,safety nets, no 01 safety nets Balcony Safety Nets,
Children Safety Nets,
Industrial Safety Nets,
Pets Safety Nets,
Ducteria Nets,
Monkey Safety Nets,
Cricket Practice Nets,
Bird Spikes"
                className="w-full h-64 object-cover"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

Images.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Images;
